<template>
  <div class="trRefundDetail linear-main3">
    <ld-header
      transparent
      white
      @click-left="$router.push({ path: '/allorder', query: { findType: '4' }})"
    >
      退票详情
    </ld-header>

    <van-pull-refresh
      class="train-detail-content"
      v-model="isLoading"
      @refresh="getDetail"
    >
      <div class="pad16 white">
        <div class="font-lg font24 fontTitle">
          <span>{{ detail.refundStatusDesc }}</span>
          <ld-email-popup
            v-if="id"
            :id="id"
            :djlx="11010"
            :order-no="detail.orderNo"
          />
        </div>
        <van-row class="font12">
          {{ $t('K121','申请时间') }}：{{ detail.applyDate }}
        </van-row>
        <van-row class="font12">
          {{ $t('K138','申请人') }}：
          {{ detail.applyUserName }}&nbsp;&nbsp;
          {{ detail.applyDeptName }}
        </van-row>
        <van-row class="font12">
          {{ $t('I208','退票原因') }}：{{ detail.refundReasonVip }}
        </van-row>
        <van-notice-bar
          v-if="detail.isReject"
          class="clbz-bar"
          mode="link"
          :scrollable="false"
          @click="$dialog({title: $t('C452','拒单原因'), message: detail.errMsg})"
        >
          <span>{{ $t('C452','拒单原因') }}：{{ detail.errMsg }}</span>
        </van-notice-bar>
        <van-notice-bar
          v-if="detail.tsTpgzts"
          class="clbz-bar"
          mode="link"
          :scrollable="false"
          @click="$dialog({title: $t('C474','提示'), message: detail.tsTpgzts})"
        >
          <span>{{ $t('C474','提示') }}：{{ detail.tsTpgzts }}</span>
        </van-notice-bar>
      </div>

      <div
        class="pad8"
        v-if="detail.orderNo"
      >
        <van-row class="round-sm pad8 van-row bg-white">
          退单编号：{{ detail.orderNo }}

          <router-link
            class="main-color fr"
            :to="`/tr/OrderDetail/${detail.trOrderId}`"
          >
            {{ $t('C338','查看原订单') }}
          </router-link>
        </van-row>

        <!-- 支付方式 -->
        <van-row
          v-if="detail.payMethodDesc"
          class="round-sm pad8 orange bg-lightYellow"
        >
          {{ detail.payMethodDesc }}
        </van-row>

        <!-- 原订单信息 -->
        <div class="bg-white round-sm mt5">
          <stop-station
            class="van-hairline--bottom"
            :detail="detail"
            train-no-class="main-color"
          />
          <van-row class="font12 pad8 text-center">
            <router-link
              to="/tr/OrderService"
              class="main-color"
            >
              {{ $t('F010','退改签规则') }}
            </router-link>
          </van-row>
        </div>



        <!-- 乘车人列表 -->
        <van-cell-group class="psg-cnt mt5 round-sm">
          <psg-panel
            :key="detail.id"
            :passenger="detail.passenger"
          />
        </van-cell-group>
        <approval
          class="mt5 round-sm"
          v-if="detail.appId"
          :order-id="id"
          :vip-status="detail.vipStatus"
          :spgz-id="detail.appId"
          :isssbz="detail.showSendApp!='1'"
        />
        <ld-uploader
          class="mt5 round-sm overflow"
          v-if="id"
          :order-id="id"
          :glywlx="'11010'"
          :cjlx="2"
          :orderStatus='detail.refundStatus'
        />



        <!-- 退票进度 -->
        <!-- <van-cell class="mt5">
          <h3>退票进度：</h3>
        </van-cell>
        <van-steps
          class="ld-step"
          direction="vertical"
          :active="detail.refundStatus"
        >
          <van-step>
            <h3>申请已提交</h3>
            <p class="mt5">
              {{ detail.applyDate }}
            </p>
          </van-step>
          <van-step>
            <h3>送审</h3>
          </van-step>
          <van-step>
            <h3>办理退票中</h3>
          </van-step>
          <van-step>
            <h3>办理完成</h3>
          </van-step>
          <van-step>
            <h3>退款</h3>
          </van-step>
        </van-steps> -->
      </div>
    </van-pull-refresh>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        class="full-width bg-white shadow"
        type="flex"
        align="center"
        justify="space-between"
        @click="$refs['tabbar'].toggle()"
      >
        <van-col
          offset="1"
          span="11"
        >
          应退金额：
          <span class="font12 red">&yen;</span>
          <span class="font16 red">{{ detail.cuRefundAmount }}</span>
          {{ $t('E006','明细') }}
          <van-icon
            name="arrow-up"
            class="vertical-middle"
            size="14"
          />
        </van-col>
        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            defaults
            size="md"
            class="font12"
            v-if="detail.showCancel == 1"
            @click.stop="btnClick('cancel')"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>

        <van-col
          span="6"
          class="pad5"
        >
          <ld-button
            v-if="detail.isShowCancelApproval == 1"
            defaults
            size="md"
            @click.native="btnClick('revertApproval')"
          >
            {{ $t('B065','撤回') }}
          </ld-button>
          <ld-button
            main
            size="md"
            v-if="detail.showSendApp == 1"
            @click.stop="btnClick('approval')"
          >
            {{ $t('B028','送审') }}
          </ld-button>
          <ld-button
            main
            size="md"
            class="font12"
            v-if="detail.showSendApp == 2"
            @click.stop="btnClick('approval')"
          >
            {{ $t('Submit','再送审') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票退票详情
 * @desc
 * @param {String} id 火车票退票订单id
 */

import { CellGroup, Cell, PullRefresh, Step, Steps, NoticeBar, Popup } from 'vant'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import ldButton from 'Common/ldButton'
import StopStation from '../trQuery/StopStation'
import PsgPanel from '../trOrder/PsgPanel'
import handle from './handle'
import approval from 'Components/approval/approval'

import TrainOrderInteractor from 'Domain/use-cases/train-order-interactor'
import ldEmailPopup from 'Components/LdEmailPopup'
import ldUploader from 'Components/ldUploader'


export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [PullRefresh.name]: PullRefresh,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [NoticeBar.name]: NoticeBar,
    [Popup.name]: Popup,
    StopStation,
    PsgPanel,
    ldButton,
    ldTabbar,
    approval,
    ldEmailPopup,
    ldUploader
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      detail: {},
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.isLoading = true

      const { data } = await TrainOrderInteractor.getRefundDetailById(this.id)

      this.isLoading = false
      this.detail = data
    },
    async btnClick (handleType) {
      if (handle[handleType]) {
        await handle[handleType](this.detail)
        this.getDetail()
      }
    }
  },
  computed: {
    priceList () {
      return [
        { name: '应退合计', price: this.detail.cuRefundAmount },
        { name: '成人', price: this.detail.ticketPrice },
        { name: '退票手续费', price: this.detail.cuRefundPoundage, amount: this.detail.ticketNumber || 1, unit: '人' },
        { name: '加收服务费', price: this.detail.sellServiceCharge, amount: this.detail.ticketNumber || 1, unit: '人' },
        { name: '退服务费', price: this.detail.refundServiceCharge, amount: this.detail.ticketNumber || 1, unit: '人' },
      ]
    }
  }
}
</script>

<style lang="less">
@import "~Assets/styles/business.less";
.trRefundDetail {
  .fontTitle{
    display: flex;
    justify-content:space-between;
    align-items:center;
    .dowPdf{
      font-size: 16px;
    }
  }
  p, h3 {
    margin: 0;
  }


  .pad5 {
    padding: 5px;
  }

  .pad8 {
    padding: 8px;
  }

  .pad16{
    padding: 16px;
  }
  .mt5 {
    margin-top: 5px;
  }
  .train-detail-content {
    padding-bottom: 60%;
  }

  .round-sm {
    overflow: hidden;
  }

  .StopStation {
    > .van-row {
      color: @color-text-black;
    }
  }
}
</style>
